/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningOutcomeTemplateDTO,
    LearningOutcomeTemplateDTOFromJSON,
    LearningOutcomeTemplateDTOFromJSONTyped,
    LearningOutcomeTemplateDTOToJSON,
} from './LearningOutcomeTemplateDTO';

/**
 * 
 * @export
 * @interface FundamentalDomainUpdateDTO
 */
export interface FundamentalDomainUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof FundamentalDomainUpdateDTO
     */
    name: string;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof FundamentalDomainUpdateDTO
     */
    learningOutcomeTemplates?: Array<LearningOutcomeTemplateDTO> | null;
}

export function FundamentalDomainUpdateDTOFromJSON(json: any): FundamentalDomainUpdateDTO {
    return FundamentalDomainUpdateDTOFromJSONTyped(json, false);
}

export function FundamentalDomainUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundamentalDomainUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'learningOutcomeTemplates': !exists(json, 'learningOutcomeTemplates') ? undefined : (json['learningOutcomeTemplates'] === null ? null : (json['learningOutcomeTemplates'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
    };
}

export function FundamentalDomainUpdateDTOToJSON(value?: FundamentalDomainUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'learningOutcomeTemplates': value.learningOutcomeTemplates === undefined ? undefined : (value.learningOutcomeTemplates === null ? null : (value.learningOutcomeTemplates as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
    };
}

